import React, { useEffect } from 'react'

import { InsurancePremiumResponse, getInsurancePremiums } from 'core'

import { Avatar, Card, Col, Icon, Row } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import InsurancePremiumCard from './insurancePremiumCard/InsurancePremiumCard'

type PremiumsProps = {
  planPeriodId: string
}
const Premiums: React.FC<PremiumsProps> = ({ planPeriodId }) => {
  const {
    data: insurancePremiums,
    sendQuery: sendGetPremiums,
    isLoading,
  } = useQueryRequestV2<InsurancePremiumResponse[]>({})

  useEffect(() => {
    if (planPeriodId) {
      ;(async () => {
        await sendGetPremiums(() => getInsurancePremiums(planPeriodId))
      })()
    }
  }, [planPeriodId])

  const onPremiumUpdated = async () => {
    await sendGetPremiums(() => getInsurancePremiums(planPeriodId))
  }

  return (
    <Card title={'Insurance Premiums'} loading={isLoading}>
      <>
        {insurancePremiums && (
          <Row gutter={16}>
            {insurancePremiums.map((item) => (
              <Col xs={24} sm={24} md={8} key={item.id}>
                <InsurancePremiumCard
                  insurancePremium={item}
                  planPeriodId={planPeriodId}
                  onPremiumUpdated={onPremiumUpdated}
                />
              </Col>
            ))}
          </Row>
        )}

        {!insurancePremiums ||
          (insurancePremiums.length == 0 && (
            <div className={'insurance-premium-col'}>
              <Avatar
                size="large"
                className="center_avatar insurance-premium-avatar"
                icon={<Icon className="far fa-money-check-alt color-green-6" />}
              />
              <div className="text-center" style={{ margin: 'auto' }}>
                <div className="allowances-statistics_card-title">
                  <span className="allowances-statistics_card-zero-state-text semi-bold">
                    No insurance premiums yet...
                  </span>
                </div>
                <div>
                  <span className="allowances-statistics_card-zero-state-paragraph">
                    Get reimbursed for your insurance premiums.
                  </span>
                </div>
                <span className="allowances-statistics_card-zero-state-paragraph">
                  When your request is verified, you’ll be set for the rest of the year (unless your premium changes).
                </span>
              </div>
            </div>
          ))}
      </>
    </Card>
  )
}

export default Premiums
